import React, { Component } from 'react';
import QualifyView from 'views/QualifyView';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { didShareOn } from 'state/actions/qualifyActions';
import get from 'utils/get';
import popupCenter from 'utils/popupCenter';
import SegmentWrapper from 'lib/segment';

const TWEET = `A chance to win a $62,000 video editing workstation? Don’t mind if I do. Thanks @Frame_io and @Adobe #dreamstation http://bit.ly/2yGhBFD`;

const FB_URL =  'https://frame.io/dreamstation?utm_source=facebook&utm_medium=share&utm_campaign=dreamstation';

class QualifyContainer extends Component {
  triggerFacebookShare = () => {
    SegmentWrapper.didClickSocialShare('facebook');
    popupCenter(`https://www.facebook.com/sharer/sharer.php?u=${FB_URL}`, 'Facebook', '600', '260');
    this.props.actions.didShareOn('facebook');
  }

  triggerTwitterShare = () => {
    SegmentWrapper.didClickSocialShare('twitter');
    popupCenter(`https://twitter.com/intent/tweet?text=${encodeURIComponent(TWEET)}`, 'Tweet', '600', '260');
    this.props.actions.didShareOn('twitter');
  }

  render() {
    return (
      <QualifyView
        triggerFacebookShare={this.triggerFacebookShare}
        facebookShared={this.props.facebook}
        triggerTwitterShare={this.triggerTwitterShare}
        twitterShared={this.props.twitter}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    facebook: get(state, 'qualifyState.facebook', false),
    twitter: get(state, 'qualifyState.twitter', false)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        didShareOn
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QualifyContainer);



// WEBPACK FOOTER //
// ./src/containers/QualifyContainer.js